import React, { useContext, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";

// Importamos el componente "Todo en Uno"
import WeeklyScheduleEditor from "../../../components/schedules/WeeklyScheduleEditor";

export default function WorkingHours() {
    const { userData } = useContext(UserContext);
    useEffect(()=>{console.log('USER DATA ===> ',userData.entity.id)},[])
    // Obtenemos el ID del Merchant (asegúrate que la ruta al ID sea correcta)
    const merchantId = userData.entity.id;

    return(
        <Box sx={{ width: '100%', p: 2 }}>
            <Box mb={3}>
                <Typography variant="h6" fontWeight="bold">Horario Comercial</Typography>
                <Typography variant="body2" color="text.secondary">
                    Define las horas generales de apertura y cierre de tu negocio.
                </Typography>
            </Box>

            {/* ¡MAGIA! Solo instanciamos el componente */}
            <WeeklyScheduleEditor 
                resourceType="merchant" 
                resourceId={merchantId} 
            />
        </Box>
    );
}